import { Navigate, useRoutes } from "react-router"
import CompactLayout from "../layouts/CompactLayout"
import Page404 from "../layouts/Mantainance/Page404/Page404"
import RegistrationLayout from "../layouts/Registration/RegistrationLayout"

/**
 * The function defines a router with routes for enrollment and a generic 404 page, and redirects all
 * other paths to the enrollment page.
 * @returns A function component called `Router` that returns a set of routes defined using the
 * `useRoutes` hook. The routes include a path for enrollment, a generic path for a 404 error page, and
 * a catch-all path that redirects to the enrollment page. The enrollment page is rendered using a
 * `RegistrationLayout` component, while the 404 page is rendered using a `Page404` component.
 */
const Router = () => {
    // Auth
    return useRoutes([
        // enroll
        {
            path:'enroll',
            element: <RegistrationLayout />
        },
        // Generico
        {
            element: <CompactLayout />,
            children:[
                {
                    path:'404',
                    element: <Page404 />
                },
            ]
        },
        { path: '*', element: <Navigate to="/enroll" replace /> },
    ])
}

export default Router